export const simpleAppreciationFrame = () => ({
  id: 'simple-appreciation-frame',
  name: 'Simple Appreciation Frame',
  thumbnail: '/assets/diploma-templates/02_frame.webp',
  data: {
    elements: [],
    backgroundColor: '#fffdf9',
    backgroundImage: {
      url: '/assets/diploma-templates/backgrounds/02_background.svg',
      key: null
    }
  }
});
